import { render, staticRenderFns } from "./CourseSessionAttendees.vue?vue&type=template&id=308ac640&scoped=true"
import script from "./CourseSessionAttendees.vue?vue&type=script&lang=ts"
export * from "./CourseSessionAttendees.vue?vue&type=script&lang=ts"
import style0 from "./CourseSessionAttendees.vue?vue&type=style&index=0&id=308ac640&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308ac640",
  null
  
)

export default component.exports